import { type FileExtensionName, fileExtensionStylingMap, genericFile } from './types';

export const getExtStyles = (ext: string) => {
  const normalizedExt = ext?.toLowerCase() || ''; // to support e.g. JPG
  return normalizedExt in fileExtensionStylingMap
    ? fileExtensionStylingMap[normalizedExt as FileExtensionName]
    : genericFile;
};
